/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateOrganizationIPWhitelistResponseData } from './CreateOrganizationIPWhitelistResponseData';
import {
    CreateOrganizationIPWhitelistResponseDataFromJSON,
    CreateOrganizationIPWhitelistResponseDataFromJSONTyped,
    CreateOrganizationIPWhitelistResponseDataToJSON,
} from './CreateOrganizationIPWhitelistResponseData';

/**
 * 
 * @export
 * @interface DeleteOrganizationIPWhitelistResponse
 */
export interface DeleteOrganizationIPWhitelistResponse {
    /**
     * 
     * @type {CreateOrganizationIPWhitelistResponseData}
     * @memberof DeleteOrganizationIPWhitelistResponse
     */
    data?: CreateOrganizationIPWhitelistResponseData;
}

/**
 * Check if a given object implements the DeleteOrganizationIPWhitelistResponse interface.
 */
export function instanceOfDeleteOrganizationIPWhitelistResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeleteOrganizationIPWhitelistResponseFromJSON(json: any): DeleteOrganizationIPWhitelistResponse {
    return DeleteOrganizationIPWhitelistResponseFromJSONTyped(json, false);
}

export function DeleteOrganizationIPWhitelistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteOrganizationIPWhitelistResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CreateOrganizationIPWhitelistResponseDataFromJSON(json['data']),
    };
}

export function DeleteOrganizationIPWhitelistResponseToJSON(value?: DeleteOrganizationIPWhitelistResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateOrganizationIPWhitelistResponseDataToJSON(value.data),
    };
}

